export default __webpack_public_path__ + "static/media/equipe-la-estancilla.8f44f96e.jpg";